import { useMutation } from '@apollo/client';
import useGetUser from './useGetUser';
import { LOAD_NEW_INVOICES } from '../graphql';

const useLoadNewInvoices = () => {
  const user = useGetUser();

  const selectedCompanyHasSiiCredentials = Boolean(
    user?.selectedCompany && user?.selectedCompany?.hasSiiCredentials,
  );

  const [loadNewInvoices, { loading, error }] = useMutation(LOAD_NEW_INVOICES, {
    onError: () => {},
  });

  return {
    loading,
    error,
    loadNewInvoices,
    selectedCompanyHasSiiCredentials,
  };
};

export default useLoadNewInvoices;
